import React, { useState } from "react";
import { BrowserRouter } from "react-router-dom";
import Rotas from "./Routers/routes";
import { AuthProvider } from "./context/AuthContext";

function App() {
  return (
    <>
      <Rotas />
    </>
  );
}

export default App;
